import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import Select2 from 'react-select/lib/Creatable';
import { api } from '@src/services/api';
import { checkLevel, isLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

export interface DepLocalProps extends PropsEdit {
    urlCreateDepartment: string;
}
export interface DepLocalState extends StateEdit {
    departmentSelectLoading: boolean;
    departmentSelectValue: any;
    data: any;
}

export class BatteryDepartments<T extends DepLocalProps, S extends DepLocalState> extends ProtoEdit<T, S> {
    
    async addDepartment(formApi, custid, dept) {
        const { urlCreateDepartment } = this.props;
        const { data } = this.state;
        try {
            this.setState({ departmentSelectLoading: true })
            const res = await api({
                url: urlCreateDepartment,
                method: "POST",
                data: {
                    custid,
                    description: dept
                }
            });
            const value = res.data.data.id;
            // manual appending
            data.customers = data.customers.map( v => {
                if (v.id === custid) {
                    v.departments.push( { deptid: `${value}`, description: dept })
                }
                return v;
            } );
            this.setState({
                departmentSelectLoading: false,
                departmentSelectValue: `${value}`,
                data
            })
        } catch(e) {
        }
    }

    changedDepartment(formApi, value, action) {
        this.setState({
            departmentSelectValue: value.value,
        })
    }
}

// typing
interface LocalProps extends DepLocalProps {
    action: "sell" | "rent"
}
interface LocalState extends DepLocalState {
    departmentSelectValue: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Battery extends BatteryDepartments<LocalProps, LocalState> {

    localSave( v ) {
        v = { ...v, deptid: this.state.departmentSelectValue };
        this.save(v, _('confirm_question'));
    }

	// render
	render() {

        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel, action } = this.props;
        const { data, values = {}, entity = null, error, departmentSelectLoading, departmentSelectValue } = this.state;
        if (entity === null) return null;
        if (!data) return null;

        const key = action === "sell" ? "ownercustid" : "custid";
        const customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        const custid = values[key] || (entity ? entity['custid'] : null);
        let departments = [] as any;
        if (custid) {
            const fs = data.customers.filter( v => v.id === custid );
            if (fs.length > 0) {
                departments = fs[0].departments.map( v => ({ value: `${v.deptid}`, label: v.description }));
            }
        }
        
        return (
            <Modal
                title={_(`${action}_battery_title`, 'SettingsBattery') }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.localSave({ [key]: v[key] })}
                        defaultValues={entity}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ values: formApi.getFormState().values }); }) }
                        >
                            <div className="fields">
                                <article className="full">
                                    <label htmlFor="custid">{_('field_custid', 'SettingsBattery')}</label>
                                    <Select field={key} id="custid" options={customers} className="form-control" />
                                </article>
                                {custid && !checkLevel('hyster') &&
                                <article>
                                    <label htmlFor="deptid">{_('field_deptid', 'SettingsBattery')}</label>
                                    {!isLevel('customer') &&
                                    <Select2
                                        field="deptid"
                                        id="deptid"
                                        options={departments}
                                        onCreateOption={(v) => this.addDepartment(formApi, values[key], v)}
                                        isDisabled={departmentSelectLoading}
                                        isLoading={departmentSelectLoading}
                                        value={departments.filter( (v) => (v.value === departmentSelectValue) )[0] }
                                        onChange={(value, action) => this.changedDepartment(formApi, value, action)}
                                    />
                                    }
                                    {isLevel('customer') &&
                                    <Select field="deptid" id="deptid" options={departments} className="form-control" />
                                    }
                                </article>
                                }
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                    {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    {action === 'sell' ? 'Sell' : 'Rent'}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Actions/Battery.tsx